/**
 * Fragment de routes du paquet v1-p06-accueil (vague V1), actif sans condition depuis le retrait du drapeau
 * `navigationV10` (R3, 02/11). Composants chargés à la demande (règle de chargement du registre).
 * Routes du socle remplacées (`remplace: true`), d'après le `couvre: route:` des YAML d'écrans :
 *  - `/`, `/mon-travail` → transverse-accueil ;
 *  - `/attention`, `/hitl-cockpit` → transverse-attention ;
 *  - `/notifications` → transverse-notifications ;
 *  - `/invitations` → transverse-mes-demandes.
 * Routes neuves : `/recherche` (transverse-recherche, `couvre: coquille/recherche`) et `/acces-projet?espace=…`
 * (projet-acces) : hors de `/projet/**` et sans `?projet=`, pour que la porte de la coquille (`PorteProjet`) ne
 * l'intercepte pas (critique P12 n° 1).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const Accueil = lazy(() => import('../ecrans/v1/accueil/Accueil'))
const Attention = lazy(() => import('../ecrans/v1/accueil/Attention'))
const Notifications = lazy(() => import('../ecrans/v1/accueil/Notifications'))
const Recherche = lazy(() => import('../ecrans/v1/accueil/Recherche'))
const MesDemandes = lazy(() => import('../ecrans/v1/accueil/MesDemandes'))
const ProjetAcces = lazy(() => import('../ecrans/v1/accueil/ProjetAcces'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v1-accueil',
  routes: [
    { chemin: '/', element: ecran(Accueil), remplace: true },
    { chemin: '/mon-travail', element: ecran(Accueil), remplace: true },
    { chemin: '/attention', element: ecran(Attention), remplace: true },
    { chemin: '/hitl-cockpit', element: ecran(Attention), remplace: true },
    { chemin: '/notifications', element: ecran(Notifications), remplace: true },
    { chemin: '/invitations', element: ecran(MesDemandes), remplace: true },
    { chemin: '/recherche', element: ecran(Recherche) },
    { chemin: '/acces-projet', element: ecran(ProjetAcces) },
  ],
}
